addEventListener("DOMContentLoaded", (event) => {

    const videos        = document.querySelectorAll(".video__item");
    const videoStateMap = new Map();

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting && !videoStateMap.get(target)) {
                let player  = target.querySelector("video");
                let button  = target.querySelector(".video__play");
        
                button.style.display = "none";
                player.play();

                videoStateMap.set(target, true);
            }
        });
    });

    videos.forEach((video) => {
        videoStateMap.set(video, false);
        observer.observe(video);
    });

});